<template>
  <div>
    <div class="input-label">
      <label class="caption1 color-secondary-600 bold mb-2"
        >Nome da empresa</label
      >
      <input type="text" placeholder="Ex.: SENAI" v-model="value.companyName" />
    </div>
    <div class="input-label">
      <label class="caption1 color-secondary-600 bold mb-2"
        >Qual era seu cargo?</label
      >
      <input type="text" placeholder="Nome do cargo" v-model="value.jobName" />
    </div>
    <div class="d-flex flex-column flex-md-row">
      <div class="input-label w-100">
        <label class="caption1 color-secondary-600 bold mb-2"
          >Data de início</label
        >
        <datepicker v-model="value.dateInit" :language="translationDatePicker" :clear-button="true" input-class="limited-datepicker w-100" placeholder="mês/ano" minimum-view="month" :format="DatePickerFormat"></datepicker>
      </div>
      <div class="input-label ml-md-32 w-100" v-if="!value.isActualJob">
        <label class="caption1 color-secondary-600 bold mb-2"
          >Data de conclusão</label
        >
        <datepicker v-model="value.dateFinish" :language="translationDatePicker" :clear-button="true" input-class="limited-datepicker w-100" placeholder="mês/ano" minimum-view="month" :format="DatePickerFormat"></datepicker>
      </div>
    </div>
    <div class="d-flex justify-content-md-end mr-3">
      <div
        class="
          checkbox-radio-group checkbox-trabalho
          justify-self-end
          pl-0 pl-md-2
        "
      >
        <input
					v-model="value.isActualJob"
          type="checkbox"
          name=""
          class="checkbox checkbox-trabalho"
        />
        <label class="body2 color-black">É meu emprego atual</label>
      </div>
    </div>
    <div class="input-label">
      <label class="caption1 color-secondary-600 bold mb-2"
        >Fale sobre suas atribuições e aprendizados</label
      >
      <textarea
        name="w3review"
        rows="6"
        cols="50"
				v-model="value.about"
        placeholder="Descreva atividades desenvolvidas, resultados obtidos, mudanças na carreira..."
      ></textarea>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { ptBR } from "vuejs-datepicker/dist/locale";

export default {
  name: "ExperienceForm",
  props: ["value"],
  components: {
    Datepicker,
  },
  data() {
		return {
			translationDatePicker: ptBR,
      DatePickerFormat: 'MM/yyyy',
		};
  },
  watch: {
    "value.isActualJob"(val) {
      if (val) {
        this.value.dateFinish = null;
      }
    }
  }
};
</script>

<style scoped>
</style>
